function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import { isFieldPath } from "../../fieldPath";
export var IPatternType;
(function(IPatternType2) {
  IPatternType2["single"] = "single";
  IPatternType2["array"] = "array";
  IPatternType2["object"] = "object";
})(IPatternType || (IPatternType = {}));
export class Pattern {
  static getType(pattern) {
    if (Array.isArray(pattern)) {
      return IPatternType.array;
    }
    if (typeof pattern === "object") {
      if (this.NOT_OBJECT.every((func) => !func(pattern))) {
        return IPatternType.object;
      }
    }
    return IPatternType.single;
  }
  static transformPattern(pattern, exector) {
    const type = this.getType(pattern);
    if (type === IPatternType.array) {
      const _pattern = pattern;
      return _pattern.map((item, index) => exector(item, index));
    }
    if (type === IPatternType.object) {
      const _pattern = pattern;
      const obj = {};
      for (const entry of Object.entries(_pattern)) {
        const [key, p] = entry;
        obj[key] = exector(p, key);
      }
      return obj;
    } else {
      const _pattern = pattern;
      return exector(_pattern);
    }
  }
}
_define_property(Pattern, "NOT_OBJECT", [
  (item) => isFieldPath(item)
]);
